import React, { Component } from 'react';
import {Field, reduxForm, formValueSelector, change} from 'redux-form';
// import { Link, Redirect } from 'react-router-dom';

import Check from './fields/check';
import Text from './fields/text';
import TextNumber from './fields/textNumber';
import Select from './fields/select';
import Textarea from './fields/textarea';
import Isvg from 'react-inlinesvg';
import { connect } from 'react-redux';

import { Container, Row, Col } from 'reactstrap';

const required = (value) => (value ? undefined : 'Required');
const renderTextNumberField = ({
  input,
  label,
  placeholder,
  disabled,
  meta: { touched, error },
  type,
}) => (
  <TextNumber
    placeholder={placeholder}
    errorText={touched && error}
    label={label}
    disabled={disabled}
    error={touched && error}
    type={type}
    {...input}
  />
);

const renderCheckField = ({
  input,
  placeholder,
  label,
  meta: { touched, error },
}) => (
  <Check
    placeholder={placeholder}
    label={label}
    errorText={touched && error}
    error={touched && error}
    // multilang={multilang}
    // lang={lang}

    {...input}
  />
);

const renderSelectField = ({
  input,
  placeholder,
  label,
  meta: { touched, error },
  children,
  additionalAction,
  scope,
  disabled,
}) => (
  <Select
    placeholder={placeholder}
    label={label}
    errorText={touched && error}
    error={touched && error}
    additionalAction={additionalAction}
    scope={scope}
    disabled={disabled}
    {...input}
    children={children}
  />
);

const renderTextField = ({
  input,
  label,
  placeholder,
  meta: { touched, error },
  type,
  disabled,
}) => (
  <Text
    placeholder={placeholder}
    errorText={touched && error}
    label={label}
    error={touched && error}
    type={type}
    disabled={disabled}
    {...input}
  />
);

const renderTextareaField = ({
  input,
  placeholder,
  label,
  meta: { touched, error },
}) => (
  <Textarea
    placeholder={placeholder}
    label={label}
    errorText={touched && error}
    error={touched && error}
    {...input}
  />
);

class CartAddressForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      seePassword: false,
      disabledCountrySelect: false,
      showNorway: false,
      allowTextPostalcode: false,
      country: null,
      show: false
    };
  }
  componentDidUpdate(prevProps, prevState, snapshot) {

   if(prevState.country !== this.state.country) {
     if(this.state.country === 'NL') {
       this.setState({
         allowTextPostalcode: true
       })
     }
    }

  }

  async componentDidMount () {

    const priceListCountryMap = {
      'Price list AT': 'AT',
      'Price list DE': 'DE',
      'Price list DK': 'DK',
      'Price list NL': 'NL',
      'Price list BE': 'BE',
      'Price list FR': 'FR',
      'Price list LV': 'LV',
      'Price list SE': 'SE',
    }
    const countryValues = [
      '', 'AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GR', 'HR',
      'HU', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'NO', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK', 'GB','CH'
    ];
    const {customerGroups = []} = this.props.initialValues;
    const {customerData } = this.props.initialValues;
    const priceListNames = Object.keys(priceListCountryMap);
    const targetPriceList =  customerGroups.find(group => priceListNames.includes(group.name));
    if(customerData && customerData.id === '774') {
     await this.setState({showNorway : true})
    }
    if(!countryValues.includes(this.props.initialValues.shippingData.country)) {
     await this.props.changeCountry('');
     await this.setState({
        country: ''
      })
    }
    if (targetPriceList && targetPriceList.name) {
      const countryCode = priceListCountryMap[targetPriceList.name];

      if (countryCode) {
        this.props.changeCountry(countryCode);
        this.setState({
          country: countryCode
        })
        this.setState({
          disabledCountrySelect: true
        });
      }
    }
    this.setState({
      show: true
    })
  }

  render() {
    const {handleSubmit, pristine, reset, submitting} = this.props;

    return (
        <form onSubmit={handleSubmit} className="login-form accoutn-info-form">
        {!this.props.sameAsBillingAddress ? (
          <Row>
            <Col lg="12">
              <div className="field-wrap">
                <Field
                  disabled={this.props.deliveryTo !== 'custom'}
                  name="shippingData.company"
                  component={renderTextField}
                  label={'Företagsnamn eller Förnamn och Efternamn *'.translate(
                    this.props.lang,
                  )}
                  validate={[required]}
                ></Field>
              </div>
            </Col>
            <Col lg="12">
              <div className="field-wrap">
                {this.state.show ?
                    <Field
                        name="shippingData.country"
                        component={renderSelectField}
                        label={'Land/Region *'}
                        validate={[required]}
                        disabled={this.state.disabledCountrySelect || this.props.deliveryTo !== 'custom'}
                        onChange={(value) => {
                          if(value === 'NL') {
                            this.setState({
                              allowTextPostalcode: true
                            })
                          } else {
                            this.setState({
                              allowTextPostalcode: false
                            })
                          }
                          this.setState({
                            country: value
                          })
                        }}
                    >
                      <option value="">{'Välj land / region...'.translate(this.props.lang)}</option>
                      <option value="AT">{'Österrike'.translate(this.props.lang)}</option>
                      <option value="BE">{'Belgien'.translate(this.props.lang)}</option>
                      <option value="BG">{'Bulgarien'.translate(this.props.lang)}</option>
                      <option value="CY">{'Cypern'.translate(this.props.lang)}</option>
                      <option value="CZ">{'Tjeckien'.translate(this.props.lang)}</option>
                      <option value="DE">{'Tyskland'.translate(this.props.lang)}</option>
                      <option value="DK">{'Danmark'.translate(this.props.lang)}</option>
                      <option value="EE">{'Estland'.translate(this.props.lang)}</option>
                      <option value="ES">{'Spanien'.translate(this.props.lang)}</option>
                      <option value="FI">{'Finland'.translate(this.props.lang)}</option>
                      <option value="FR">{'Frankrike'.translate(this.props.lang)}</option>
                      <option value="GR">{'Grekland'.translate(this.props.lang)}</option>
                      <option value="HR">{'Kroatien'.translate(this.props.lang)}</option>
                      <option value="HU">{'Ungern'.translate(this.props.lang)}</option>
                      <option value="IE">{'Irland'.translate(this.props.lang)}</option>
                      <option value="IT">{'Italien'.translate(this.props.lang)}</option>
                      <option value="LT">{'Litauen'.translate(this.props.lang)}</option>
                      <option value="LU">{'Luxemburg'.translate(this.props.lang)}</option>
                      <option value="LV">{'Lettland'.translate(this.props.lang)}</option>
                      <option value="MT">{'Malta'.translate(this.props.lang)}</option>
                      <option value="NL">{'Nederländerna'.translate(this.props.lang)}</option>
                      {this.state.showNorway === true || this.props.deliveryTo !== 'custom' ?
                          <option value="NO">{'Norge'.translate(this.props.lang)}</option>
                          : <option></option>
                      }
                      <option value="PL">{'Polen'.translate(this.props.lang)}</option>
                      <option value="PT">{'Portugal'.translate(this.props.lang)}</option>
                      <option value="RO">{'Rumänien'.translate(this.props.lang)}</option>
                      {this.props.deliveryTo !== 'custom' ?
                          <option value="CH">{'Schweiz'.translate(this.props.lang)}</option>
                          : <option></option>
                      }
                      <option value="SE" selected="selected">{'Sverige'.translate(this.props.lang)}</option>
                      <option value="SI">{'Slovenien'.translate(this.props.lang)}</option>
                      <option value="SK">{'Slovakien'.translate(this.props.lang)}</option>
                      <option value="GB">{'Storbritannien'.translate(this.props.lang)}</option>


                    </Field>

                    : null}
              </div>
            </Col>
            <Col lg="12">
            <div className="field-wrap">
                <Field
                    disabled={this.props.deliveryTo !== 'custom'}
                    name="shippingData.address1"
                    component={renderTextField}
                    label={'Gatuadress *'.translate(this.props.lang)}
                    validate={[required]}
                ></Field>
              </div>
            </Col>
            {/* <Col lg="6" style={{ marginTop: 27 }}>
                                <div className="field-wrap">
                                    <Field
                                        name="shippingData.address2"
                                        component={renderTextField}
                                    ></Field>
                                </div>
                            </Col> */}
            <Col lg="12">
              <div className="field-wrap">
                <Field
                    disabled={this.props.deliveryTo !== 'custom'}
                    name="shippingData.postalCode"
                    component={this.state.allowTextPostalcode ? renderTextField : renderTextNumberField}
                    label={'Postnummer *'.translate(this.props.lang)}
                  validate={[required]}
                ></Field>
              </div>
            </Col>
            <Col lg="12">
              <div className="field-wrap">
                <Field
                  disabled={this.props.deliveryTo !== 'custom'}
                  name="shippingData.city"
                  component={renderTextField}
                  label={'Ort *'.translate(this.props.lang)}
                  validate={[required]}
                ></Field>
              </div>
            </Col>
            <Col lg="12">
              <div className="field-wrap">
                <Field
                  disabled={this.props.deliveryTo !== 'custom'}
                  name="shippingData.phone"
                  component={renderTextField}
                  label={'Telefon *'.translate(this.props.lang)}
                  validate={[required]}
                ></Field>
              </div>
            </Col>
            <Col lg="12">
              <div className="field-wrap">
                { this.props.deliveryTo === 'custom' ?
                    <Field
                        name='deliveryNotificationEmail'
                        component={renderTextField}
                        label={'E-postadress *'.translate(this.props.lang)}
                        validate={[required]}
                    ></Field>
                    :
                    <Field
                        disabled={this.props.deliveryTo !== 'custom'}
                        name='shippingData.email'
                        component={renderTextField}
                        label={'E-postadress *'.translate(this.props.lang)}
                        validate={[required]}
                    ></Field>
                }
              </div>
            </Col>
          </Row>
        ) : null}
      </form>
    );
  }
}

CartAddressForm = reduxForm({
  form: 'cartAddressForm', // a unique identifier for this form
})(CartAddressForm);

// Decorate with connect to read form values
const selector = formValueSelector('cartAddressForm'); // <-- same as form name
CartAddressForm = connect((state) => {
      const deliverToDifferentAddress = selector(
          state,
          'deliverToDifferentAddress',
      );
      return {
        deliverToDifferentAddress: deliverToDifferentAddress,
      }
    },
    {
      changeCountry: (value) => change('cartAddressForm', 'shippingData.country', value)
    }
)(CartAddressForm);

export default CartAddressForm;
